export const VALUE_TONE_AHEAD_CLASS = 'text-[#5E9839]';
export const VALUE_TONE_BEHIND_CLASS = 'text-[#ED6C68]';

export function selectedValueTone(isAhead: boolean) {
  return isAhead ? { valueClassName: VALUE_TONE_AHEAD_CLASS } : { valueClassName: VALUE_TONE_BEHIND_CLASS };
}
